import React from "react";

export interface LoginResult {
    ok: boolean;
    error?: string;
}

export interface AuthContextType {
    token: string | null;
    permissions: string[];
    fullName: string;
    userId: string;
    locationId: string;
    login: (username: string, password: string) => Promise<LoginResult>;
    logout: () => void;
}

export const AuthContext = React.createContext<AuthContextType>({
    token: null,
    permissions: [],
    fullName: "",
    userId: "",
    locationId: "",
    login: (username: string, password: string) => Promise.reject<LoginResult>(),
    logout: () => {},
});